import { Component } from '@angular/core';
import { AsyncPipe, NgClass, NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { BalanceBlockComponent, FooterComponent, HeaderComponent } from '@wm-libs/core';
import { environment } from '../../../../../../src/environments/environment';
import { MatListModule, MatNavList } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { WorkersComponent } from '../../../workers/pages/workers/workers.component';
import { StatisticsComponent } from '../../../statistics/pages/statistics/statistics.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PoolAccessTokenService } from '../../../../core/services/pool-access-token.service';
import { AccessTokenInfo } from '../../../../core/interfaces/access-token.interface';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { RewardsComponent } from '../../../rewards/pages/rewards/rewards.component';

@Component({
  selector: 'app-access-token',
  templateUrl: './access-token.component.html',
  styleUrls: ['./access-token.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgStyle,
    TranslateModule,
    RouterLink,
    MatNavList,
    MatTabGroup,
    MatIconModule,
    MatSidenavModule,
    WorkersComponent,
    NgClass,
    AsyncPipe,
    StatisticsComponent,
    MatTabsModule,
    NgIf,
    NgTemplateOutlet,
    MatListModule,
    RewardsComponent,
    BalanceBlockComponent,
  ],
})
export class AccessTokenComponent {
  env = environment;
  app = 'wm-tech-pool';
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  activeTab = '';
  accessTokenInfo!: AccessTokenInfo;
  accessTokenBalance: null | number = null;

  constructor(private breakpointObserver: BreakpointObserver, private accessTokenService: PoolAccessTokenService) {
    this.accessTokenService.getAccessTokenInfo().subscribe((res) => {
      this.accessTokenInfo = res;

      this.activeTab = this.accessTokenInfo.permissions[0];

      if (this.accessTokenInfo.permissions.includes('balance')) {
        this.accessTokenService.getAccessTokenBalance().subscribe((res) => {
          this.accessTokenBalance = res;
        });
      }
    });
  }

  centerItem(tabIndex: string) {
    if (tabIndex !== 'farm') {
      this.activeTab = tabIndex;
    }

    this.isMobile$.subscribe((isMobile) => {
      if (!isMobile) {
        return;
      }

      this.scrollToActiveTab(tabIndex);
    });
  }

  scrollToActiveTab(tabIndex: string) {
    setTimeout(() => {
      const activeElement = tabIndex === 'farm' ? document.querySelector('.item-select') : document.querySelector('.active');
      if (activeElement) {
        activeElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }, 200);
  }
}
